"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * merged spec
 * merged spec
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCalculateRiskInsurance200ResponseValue = instanceOfCalculateRiskInsurance200ResponseValue;
exports.CalculateRiskInsurance200ResponseValueFromJSON = CalculateRiskInsurance200ResponseValueFromJSON;
exports.CalculateRiskInsurance200ResponseValueFromJSONTyped = CalculateRiskInsurance200ResponseValueFromJSONTyped;
exports.CalculateRiskInsurance200ResponseValueToJSON = CalculateRiskInsurance200ResponseValueToJSON;
exports.CalculateRiskInsurance200ResponseValueToJSONTyped = CalculateRiskInsurance200ResponseValueToJSONTyped;
/**
 * Check if a given object implements the CalculateRiskInsurance200ResponseValue interface.
 */
function instanceOfCalculateRiskInsurance200ResponseValue(value) {
    if (!('age' in value) || value['age'] === undefined)
        return false;
    if (!('riskPrice' in value) || value['riskPrice'] === undefined)
        return false;
    if (!('fatalAccidentInsuranceAmount' in value) || value['fatalAccidentInsuranceAmount'] === undefined)
        return false;
    if (!('anyDisabilityInsuranceAmount' in value) || value['anyDisabilityInsuranceAmount'] === undefined)
        return false;
    if (!('accidentDisabilityInsuranceAmount' in value) || value['accidentDisabilityInsuranceAmount'] === undefined)
        return false;
    if (!('dreadDiseaseInsuranceAmount' in value) || value['dreadDiseaseInsuranceAmount'] === undefined)
        return false;
    if (!('fatalAccidentInsurancePrice' in value) || value['fatalAccidentInsurancePrice'] === undefined)
        return false;
    if (!('anyDisabilityInsurancePrice' in value) || value['anyDisabilityInsurancePrice'] === undefined)
        return false;
    if (!('accidentDisabilityInsurancePrice' in value) || value['accidentDisabilityInsurancePrice'] === undefined)
        return false;
    if (!('dreadDiseaseInsurancePrice' in value) || value['dreadDiseaseInsurancePrice'] === undefined)
        return false;
    if (!('sumPrice' in value) || value['sumPrice'] === undefined)
        return false;
    return true;
}
function CalculateRiskInsurance200ResponseValueFromJSON(json) {
    return CalculateRiskInsurance200ResponseValueFromJSONTyped(json, false);
}
function CalculateRiskInsurance200ResponseValueFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'age': json['age'],
        'riskPrice': json['riskPrice'],
        'fatalAccidentInsuranceAmount': json['fatalAccidentInsuranceAmount'],
        'anyDisabilityInsuranceAmount': json['anyDisabilityInsuranceAmount'],
        'accidentDisabilityInsuranceAmount': json['accidentDisabilityInsuranceAmount'],
        'dreadDiseaseInsuranceAmount': json['dreadDiseaseInsuranceAmount'],
        'fatalAccidentInsurancePrice': json['fatalAccidentInsurancePrice'],
        'anyDisabilityInsurancePrice': json['anyDisabilityInsurancePrice'],
        'accidentDisabilityInsurancePrice': json['accidentDisabilityInsurancePrice'],
        'dreadDiseaseInsurancePrice': json['dreadDiseaseInsurancePrice'],
        'sumPrice': json['sumPrice'],
    };
}
function CalculateRiskInsurance200ResponseValueToJSON(json) {
    return CalculateRiskInsurance200ResponseValueToJSONTyped(json, false);
}
function CalculateRiskInsurance200ResponseValueToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'age': value['age'],
        'riskPrice': value['riskPrice'],
        'fatalAccidentInsuranceAmount': value['fatalAccidentInsuranceAmount'],
        'anyDisabilityInsuranceAmount': value['anyDisabilityInsuranceAmount'],
        'accidentDisabilityInsuranceAmount': value['accidentDisabilityInsuranceAmount'],
        'dreadDiseaseInsuranceAmount': value['dreadDiseaseInsuranceAmount'],
        'fatalAccidentInsurancePrice': value['fatalAccidentInsurancePrice'],
        'anyDisabilityInsurancePrice': value['anyDisabilityInsurancePrice'],
        'accidentDisabilityInsurancePrice': value['accidentDisabilityInsurancePrice'],
        'dreadDiseaseInsurancePrice': value['dreadDiseaseInsurancePrice'],
        'sumPrice': value['sumPrice'],
    };
}
